import { useState } from "react";
import { VisibleEye, NotVisibleEye } from "../svg";
import InputGuideText from "@/components/input-guide-text";
import classNames from "classnames";
import { forwardRef } from "react";

const AuthInput = forwardRef(function AuthInput(
  {
    type,
    placeholder,
    required = true,
    labelHidden = true,
    className = "",
    toWarn = false,
    warnText = "",
    ...props
  },
  ref
) {
  const [inputType, setInputType] = useState(type);
  const isPasswordInput = props.name.includes("password");

  const handlePasswordVisiblityClick = () => {
    setInputType(inputType === "password" ? "text" : "password");
  };

  const VisibilityToggleButton = () => {
    return (
      <button
        className={classNames(
          "absolute right-2 bottom-3 md:bottom-2",
          "text-subtext-gray hover:text-dark-purple focus:outline-none"
        )}
        aria-hidden="true"
        tabIndex="-1"
        onMouseDown={handlePasswordVisiblityClick}
      >
        {inputType === "password" ? <NotVisibleEye /> : <VisibleEye />}
      </button>
    );
  };

  return (
    <div className="relative">
      <label
        className="text-subtext-gray focus-within:text-dark-purple"
        htmlFor={props.id}
      >
        <p className={`${labelHidden ? "hidden" : "text-sm"}`}>{placeholder}</p>

        <input
          required={required}
          placeholder={labelHidden ? placeholder : ""}
          type={inputType}
          className={classNames(
            "block pl-2 pr-10 py-3",
            labelHidden ? "md:pt-7 md:pb-5 mt-2" : "md:py-2",
            "w-full bg-transparent border-b border-light-purple focus:border-b-2",
            "placeholder:text-subtext-gray rounded-sm focus:outline-none text-black",
            className
          )}
          ref={ref}
          {...props}
        />
      </label>
      {isPasswordInput && <VisibilityToggleButton />}
      {toWarn && (
        <InputGuideText className="absolute mt-0.5" isWarning={true}>
          {warnText}
        </InputGuideText>
      )}
    </div>
  );
});

export default AuthInput;
